export default __webpack_public_path__ + "static/media/nm.db1b4242.png";